@if (notifications$ | async; as notifies) {
  @if (notifies.length) {
    @for (notify of notifies | slice: 0 : 3; track notify) {
      <ng-container [@appearance]>
        @if (notify?.notification?.type) {
          <div class="notification-container">
            <div class="notification-container__user">
              <app-image
                class="notification-container__user-avatar"
                [img]="notify.notificationAuthor.avatar?.previewNormal | addBaseUrl"
              ></app-image>
              @if (notify.notification.type === notificationTypes.post) {
                <app-image
                  class="notification-container__user-icon"
                  [img]="'./assets/images/icons-svg/notifications/_comment.svg'"
                ></app-image>
              }
              @if (notify.notification.type === notificationTypes.photoReport) {
                <app-image
                  class="notification-container__user-icon"
                  [img]="'./assets/images/icons-svg/notifications/photo-report.svg'"
                ></app-image>
              }
            </div>
            <div class="notification-container__content">
              <div class="notification-container__content__user-name">
                <app-text
                  [textSize]="TextSizes.h4Name"
                  [textType]="TextType.base"
                  [text]="notify.notificationAuthor | getFullName"
                ></app-text>
              </div>
              <div class="notification-container__content__text">
                <app-text
                  [textSize]="TextSizes.mobInput"
                  [textType]="TextType.base"
                  text="оставил(а) комментарий"
                ></app-text>
              </div>
              <div class="notification-container__content__message">
                <app-text
                  [textSize]="TextSizes.notification"
                  [textType]="TextType.base"
                  [text]="notify.message"
                ></app-text>
              </div>
            </div>
          </div>
        }
      </ng-container>
    }
  }
}
